import apiFetch from '../apiFetch'

export default function (idRuta, token) {
  return apiFetch({endPoint: `Ruta/getRuta?idRuta=` + idRuta, method: 'GET', body: null, token: token})
}
